import { Link } from 'react-router-dom';
import { Property } from '@model';
import './AreaPropertiesTile.scss';
import { SearchByPlaceBadge } from './SearchByPlaceBadge.tsx';
import { useTranslation } from 'react-i18next';

export type AreaPropertiesTileProps = {
  properties: Property[];
  area: string;
};

export function AreaPropertiesTile(props: AreaPropertiesTileProps) {
  const { t } = useTranslation();

  const randomPropertyIndex = Math.floor(
    Math.random() * props.properties.length,
  );
  const property = props.properties[randomPropertyIndex];
  const image = property.mainImages[0];

  return (
    <Link to={`/properties?area=${props.area}`}>
      <div className='ltn__search-by-place-item'>
        <div className='search-by-place-img'>
          <img src={image.thumbUrl} alt='#' />
          <SearchByPlaceBadge properties={props.properties} />
        </div>
        <div className='search-by-place-info'>
          <h6>{props.area}</h6>
          <div className='search-by-place-btn'>
            {t('propertiesByArea.searchProperties')}{' '}
            <i className='flaticon-right-arrow'></i>
          </div>
        </div>
      </div>
    </Link>
  );
}
